import React from "react";

import DragIcon from "../../../../assets/icons/drag.svg";

const Drag = (props) => {
  return (
    <div className="drag">
      <img src={DragIcon} alt="Drag" />
    </div>
  );
};

export default Drag;
